import Banner from 'components/Banner'
import Heading from 'components/Heading'
import { Container } from 'components/layout/Grid/'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class ErrorPage extends Component {
  render() {
    const { search } = this.props.location
    const bannerName = 'Something went wrong'
    return (
      <div>
        <Banner name={bannerName} />
        <Container>
          <Heading size="large">A few tips...</Heading>
          <p>A system error has occurred, this task cannot be completed for now. Please try again later. Sorry for the inconvenience.</p>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})

export default withRouter(connect(mapStateToProps, {
})(ErrorPage))



// WEBPACK FOOTER //
// ./src/containers/ErrorPage.js